import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'
import styles from './MiniMergeSections.module.css'
import {MiniMergeStatusItem} from './MiniMergeStatusItem'

export function MiniStatusSkeletonItem({
  text,
  action,
}: {
  text?: string
  action?: (returnFocusTo?: HTMLElement | null) => void
}) {
  return (
    <MiniMergeStatusItem aria-label="Loading merge status">
      <MiniMergeStatusItem.LabelRow
        aria-label={action ? `${text ?? 'Merge status'}: view details` : undefined}
        onClick={action ? event => action(event.currentTarget) : undefined}
      >
        <span className="d-flex flex-items-center gap-1">
          {text ? (
            <MiniMergeStatusItem.Label>{text}</MiniMergeStatusItem.Label>
          ) : (
            <LoadingSkeleton variant="text" width="80px" />
          )}
        </span>

        {!action ? (
          <LoadingSkeleton variant="rounded" width="20px" height="20px" className={styles.MiniStatusLoadingIcon} />
        ) : null}
      </MiniMergeStatusItem.LabelRow>
      <LoadingSkeleton className={styles.MiniStatusProgress} variant="rounded" height="8px" />
    </MiniMergeStatusItem>
  )
}
